import React from 'react';
import { enGB } from 'date-fns/locale';
import { DateRangePickerCalendar } from 'react-nice-dates';
import './calendar-styles.css';

export default function Calendar(props) {
  return <DateRangePickerCalendar locale={enGB} {...props} />;
}
